// extracted by mini-css-extract-plugin
export default {"input":"DirectFlightSwitch-module__input___Z0s3J"};